<template>
  <div class="bottom" :class="position=='fixed'?'bottomfixed':''">
    <div class="content pr">
      <span class="free_info">免费领取价值 288元 试听课</span>
      <input type="text" class="phone_input" placeholder="请输入您的手机号" v-model="mobile" @change="mobilechange(mobile)" />
      <button class="call_btn hand_point" @click="onregister">申请免费试听</button>
      <div class="agree_info">点击一下，孩子人生“语”众不同</div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["detectscroll", "register",'mobilechange'],
  data: function () {
    return {
      mobile: "",
      position: "fixed",
    };
  },
  mounted: function () {
    let self = this;
    function detectbanner() {
      let top = document.querySelector(".common_foot").offsetTop;
      let height = document.documentElement.clientHeight;
      let scrollTop = 0;
      if (document.documentElement && document.documentElement.scrollTop) {
        scrollTop = document.documentElement.scrollTop;
      } else if (document.body) {
        scrollTop = document.body.scrollTop;
      }
      if (scrollTop + height >= top - 80) {
        if (self.position) {
          self.position = "";
        }
      } else {
        if (!self.position) {
          self.position = "fixed";
        }
      }
    }
    if (this.detectscroll) {
        detectbanner();
      window.onscroll = function () {
        detectbanner();
      };
    } else {
      this.position = "";
    }
  },
  methods: {
    onregister() {
      this.register && this.register(this.mobile);
    },
  },
};
</script>
<style scoped src="./common_bottom_notlogin.css"></style>